// import React, { useState, useRef, useEffect } from 'react'
// import { isNil } from 'lodash'
// import { connect } from 'react-redux'
// import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions'
// import { markerUpdate } from '../../../action/marker-actions'
// import { markerDeleteRequest } from '../../../action/marker-actions'
// import { disableMapObject, enableMapObject } from '../../../action/disable-map-obj-state-action'
// import { expandRightToolbar } from '../../../action/right-toolbar-state-actions'
// import './index.css'
// import { infoWindowOpenAction, } from '../../../action/infowindow-action'
// import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id'

// import { createContent, buildContent } from '../commonFunctions'
// import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
// import ConfirmRemoval from '../../../component/main-ui/left-toolbar/common/confirm-remove/index'

// import { storeMapOBj } from '../../../action/store-map-obj-action'


// const RenderMarkers = (props) => {
//   const [comfirmRemove, setComfirmRemove] = useState(false)
//   const [deleteMarkerId, setDeleteMarkerId] = useState({})
//   const [infowindowsState, setInfowindowsState] = useState(null)
//   const [previousState, setPreviousState] = useState(null)
//   const nulTheMapRef = useRef(null);
//   const clickListnerRef = useRef(null);
//   const markerData = useRef(null)
//   const secondClick = useRef(null)
//   const { expandLeftToolbar, markers, markerUpdate, storeMapObjects, mapReference, storeMapOBj, markerTypes25, vendors, activeVendors, auth, markerDeleteRequest, leftToolbarState, expandRightToolbar, infoWindowOpenAction, infoWindow, selectedObjectId, selectedObjectIdNull } = props
//   let openInfoWindow = null;
//   let token = auth.token
//   let count = 1

//   useEffect(() => {
//     if (markerData.current && !leftToolbarState.expanded) {
//       secondClick.current = markerData.current.addListener('click', clickListnerRef.current)
//     }
//   }, [leftToolbarState])
//   const handleRemoveFunction = () => {
//     if (nulTheMapRef.current) {
//       nulTheMapRef.current(deleteMarkerId.value);
//       deleteMarkerId.mapObj = null
//       setComfirmRemove(false)
//     }
//   }

//   useEffect(() => {
//     if (infoWindow && infoWindow.infoWindowFunction) {
//       infoWindow.infoWindowFunction.close()
//     }
//     setPreviousState(infowindowsState);
//     if (infoWindow.infoWindowFunction) {
//       infoWindowOpenAction(infowindowsState)
//     }
//     checkAndClose()
//   }, [infowindowsState])


//   let storeInfoBox = (value) => {
//     setInfowindowsState(value);
//     infoWindowOpenAction(value)
//   }

//   let checkAndClose = () => {
//     if (previousState) {
//       previousState.close()
//     }
//   }

//   const mapFunction = async (toAdd) => {
//     let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
//     if (!isNil(mapReference) && toAdd.length > 0) {
//       toAdd.forEach(marker => {
//         console.log('aded marker===========>', marker)
//         if (isNil(marker.mapObj)) {
//           console.log('aded marker condition satisfied===========>', marker)
//           const iconURL = marker.markerTypeId ?
//             markerTypes25.find(type => type.id === marker.markerTypeId)?.iconUrl :
//             markerTypes25.find(type => type.id === 1)?.iconUrl
//           let url = marker.markerType.vectorIconUrl ? marker.markerType.vectorIconUrl : marker.markerType.iconUrl
//           const color = marker.color;
//           const mapObj = new AdvancedMarkerElement({
//             map: mapReference,
//             content: buildContent(url, color),
//             position: { lat: marker.latitude, lng: marker.longitude },
//             title: marker.name,
//           })
//           marker['measureType'] = 'marker'
//           marker['mapObj'] = function () { return mapObj }
//           let mapListner = mapObj.addListener('click', handleClick);

//           function handleClick() {
//             selectedObjectId(marker.id)
//             if (markerData.current != mapObj && markerData.current != null) {
//               markerData.current.addListener('click', clickListnerRef.current)
//             }
//             const editFunction = (infoWindow) => {
//               props.collapseLeftToolbar()
//               expandLeftToolbar({ dialog: 'edit', editable: marker, mapObj: mapListner })
//               // disableMapObject()
//               openInfoWindow = infoWindow;
//               openInfoWindow.close();
//               // infoWindowOpenAction(null)
//               google.maps.event.clearListeners(mapObj, 'click');
//               mapReference.setCenter({ lat: marker.latitude, lng: marker.longitude })
//               mapReference.setZoom(17)
//               selectedObjectIdNull()
//             }
//             const editHuntWind = (infoWindow) => {
//               props.collapseLeftToolbar()
//               marker['huntWind'] = true
//               expandRightToolbar({ dialog: 'huntWind', data: marker })
//               openInfoWindow = infoWindow;
//               openInfoWindow.close();
//               // infoWindowOpenAction(null)
//               clickListnerRef.current = clickOnMarker
//               markerData.current = mapObj
//               setInfowindowsState(null)
//               selectedObjectIdNull()
//             }
//             let nulTheMap = async (value) => {
//               try {
//                 const res = await markerDeleteRequest(value)
//                 props.collapseLeftToolbar()
//                 mapObj.map = null
//               } catch (error) {
//                 console.log('Error at deleteFunction', error)
//               }
//             }
//             const deleteFunction = (value) => {
//               setDeleteMarkerId({ value, mapObj })
//               setComfirmRemove(true)
//               openInfoWindow.close();
//               // infoWindowOpenAction(null)
//               nulTheMapRef.current = nulTheMap;
//               setInfowindowsState(null)
//               selectedObjectIdNull()
//             }
//             const closeFunction = (infoWindow) => {
//               openInfoWindow = infoWindow;
//               openInfoWindow.close();
//               // infoWindowOpenAction(null)
//               setInfowindowsState(null)
//               selectedObjectIdNull()
//             }
//             const updateInfoWindow = (value) => {
//               openInfoWindow = value
//             }
//             const dispatchFunction = (value) => {
//               // infoWindowOpenAction(value)
//               storeInfoBox(value)
//             }

//             createContent({ mapReference, mapObj, marker, infoWindow, openInfoWindow, token }, { deleteFunction, closeFunction, editFunction, updateInfoWindow, editHuntWind }, dispatchFunction);
//           }

//           const clickOnMarker = () => {
//             handleClick()
//           }
//         }


//       })
//     }
//   }


//   console.log(markers, '================>markers')
//   if (markerTypes25 && markerTypes25.length && markerTypes25.length > 0 && !isNil(mapReference)) {
//     const vendorMarkers = activeVendors.map(id => {
//       return vendors[id] && vendors[id]['objects'] && vendors[id]['objects']['markers'] ?
//         vendors[id]['objects']['markers'].filter(marker => isNil(marker.mapObj)) : []
//     }),
//       toAdd = markers.filter(marker => {
//         return isNil(marker.mapObj)
//       }).concat(vendorMarkers.flat())
//     if (!isNil(mapReference) && toAdd.length > 0) {
//       markers && mapFunction(toAdd)
//     }
//   }

//   if (comfirmRemove) {
//     return <ConfirmRemoval cancel={() => { setComfirmRemove(false) }} remove={() => {
//       handleRemoveFunction();
//     }} type="Marker" />;
//   }
//   else {
//     return (
//       null
//     )
//   }
// }

// const mapStateToProps = state => ({
//   vendors: state.vendors,
//   activeVendors: state.activeVendors,
//   leftToolbarState: state.leftToolbarState,
//   mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
//   markers: state.markers,
//   markerTypes25: state.markerTypes25,
//   auth: state.auth,
//   infoWindow: state.infoWindow,
//   storeMapObjects: state.storeMapObjects

// })

// const mapDispatchToProps = dispatch => ({
//   expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
//   markerUpdate: marker => dispatch(markerUpdate(marker)),
//   markerDeleteRequest: id => dispatch(markerDeleteRequest(id)),
//   enableMapObject: () => dispatch(enableMapObject()),
//   disableMapObject: () => dispatch(disableMapObject()),
//   expandRightToolbar: (props) => dispatch(expandRightToolbar(props)),
//   collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
//   infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
//   selectedObjectId: (payload) => dispatch(selectedObjectId(payload)),
//   selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
//   storeMapOBj: (payload) => dispatch(storeMapOBj(payload))

// })

// export default connect(mapStateToProps, mapDispatchToProps)(RenderMarkers)

import React, { useState, useRef, useEffect } from 'react';
import { isNil } from 'lodash';
import { connect } from 'react-redux';
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions';
import { markerUpdate } from '../../../action/marker-actions';
import { markerDeleteRequest } from '../../../action/marker-actions';
import { disableMapObject, enableMapObject } from '../../../action/disable-map-obj-state-action';
import { expandRightToolbar } from '../../../action/right-toolbar-state-actions';
import './index.css';
import { infoWindowOpenAction } from '../../../action/infowindow-action';
import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id';
import { createContent, buildContent } from '../commonFunctions';
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions';
import ConfirmRemoval from '../../../component/main-ui/left-toolbar/common/confirm-remove/index';
// import { storeMapOBj } from '../../../action/store-map-obj-action';

const RenderMarkers = (props) => {
  const [comfirmRemove, setComfirmRemove] = useState(false);
  const [deleteMarkerId, setDeleteMarkerId] = useState({});
  const [infowindowsState, setInfowindowsState] = useState(null);
  const [previousState, setPreviousState] = useState(null);

  const nulTheMapRef = useRef(null);
  const clickListnerRef = useRef(null);
  const markerData = useRef(null);
  const secondClick = useRef(null);
  const markerRefs = useRef({});  // Add this to track markers on the map
  const { expandLeftToolbar, markers, markerUpdate, mapReference, markerTypes25, vendors, activeVendors, auth, markerDeleteRequest, leftToolbarState, expandRightToolbar, infoWindowOpenAction, infoWindow, selectedObjectId, selectedObjectIdNull } = props;

  let openInfoWindow = null;
  let token = auth.token;

  useEffect(() => {
    if (markerData.current && !leftToolbarState.expanded) {
      secondClick.current = markerData.current.addListener('click', clickListnerRef.current);
    }
  }, [leftToolbarState]);

  const handleRemoveFunction = () => {
    if (nulTheMapRef.current) {
      nulTheMapRef.current(deleteMarkerId.value);
      // deleteMarkerId.mapObj = null;
      setComfirmRemove(false);
    }
  };

  useEffect(() => {
    if (infoWindow && infoWindow.infoWindowFunction) {
      infoWindow.infoWindowFunction.close();
    }
    setPreviousState(infowindowsState);
    if (infoWindow.infoWindowFunction) {
      infoWindowOpenAction(infowindowsState);
    }
    checkAndClose();
  }, [infowindowsState]);

  let storeInfoBox = (value) => {
    setInfowindowsState(value);
    infoWindowOpenAction(value);
  };

  let checkAndClose = () => {
    if (previousState) {
      previousState.close();
    }
  };

  const mapFunction = async (toAdd) => {
    let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

    if (!isNil(mapReference) && toAdd.length > 0) {
      toAdd.forEach(marker => {
        if (!markerRefs.current[marker.id]) {  // Only add marker if not already on the map
        } else {
          markerRefs.current[marker.id].map = null
          // Remove the marker from markerRefs.current
          delete markerRefs.current[marker.id];
        }
        const iconURL = marker.markerTypeId
          ? markerTypes25.find(type => type.id === marker.markerTypeId)?.iconUrl
          : markerTypes25.find(type => type.id === 1)?.iconUrl;

        let url = marker.markerType.vectorIconUrl ? marker.markerType.vectorIconUrl : marker.markerType.iconUrl;
        const color = marker.color;

        const mapObj = new AdvancedMarkerElement({
          map: mapReference,
          content: buildContent(url, color),
          position: { lat: marker.latitude, lng: marker.longitude },
          title: marker.name,
        });

        marker['measureType'] = 'marker';
        marker['mapObj'] = function () { return mapObj; };

        let mapListner = mapObj.addListener('click', handleClick);

        function handleClick() {
          selectedObjectId(marker.id)
          if (markerData.current != mapObj && markerData.current != null) {
            markerData.current.addListener('click', clickListnerRef.current)
          }
          const editFunction = (infoWindow) => {
            props.collapseLeftToolbar()
            expandLeftToolbar({ dialog: 'edit', editable: marker, mapObj: mapListner })
            // disableMapObject()
            openInfoWindow = infoWindow;
            openInfoWindow.close();
            // infoWindowOpenAction(null)
            google.maps.event.clearListeners(mapObj, 'click');
            mapReference.setCenter({ lat: marker.latitude, lng: marker.longitude })
            mapReference.setZoom(17)
            selectedObjectIdNull()
          }
          const editHuntWind = (infoWindow) => {
            props.collapseLeftToolbar()
            marker['huntWind'] = true
            expandRightToolbar({ dialog: 'huntWind', data: marker })
            openInfoWindow = infoWindow;
            openInfoWindow.close();
            // infoWindowOpenAction(null)
            clickListnerRef.current = clickOnMarker
            markerData.current = mapObj
            setInfowindowsState(null)
            selectedObjectIdNull()
          }
          let nulTheMap = async (value) => {
            try {
              const res = await markerDeleteRequest(value)
              // props.collapseLeftToolbar()
              mapObj.map = null
            } catch (error) {
              console.log('Error at deleteFunction', error)
            }
          }
          const deleteFunction = (value) => {
            setDeleteMarkerId({ value, mapObj })
            setComfirmRemove(true)
            openInfoWindow.close();
            // infoWindowOpenAction(null)
            nulTheMapRef.current = nulTheMap;
            setInfowindowsState(null)
            selectedObjectIdNull()
          }
          const closeFunction = (infoWindow) => {
            openInfoWindow = infoWindow;
            openInfoWindow.close();
            // infoWindowOpenAction(null)
            setInfowindowsState(null)
            selectedObjectIdNull()
          }
          const updateInfoWindow = (value) => {
            openInfoWindow = value
          }
          const dispatchFunction = (value) => {
            // infoWindowOpenAction(value)
            storeInfoBox(value)
          }

          createContent({ mapReference, mapObj, marker, infoWindow, openInfoWindow, token }, { deleteFunction, closeFunction, editFunction, updateInfoWindow, editHuntWind }, dispatchFunction);
        }

        markerRefs.current[marker.id] = mapObj;  // Track added marker by id
      });
    }
  };


  if (markerTypes25 && markerTypes25.length && !isNil(mapReference)) {
    const vendorMarkers = activeVendors.flatMap(id => vendors[id]?.objects?.markers?.filter(marker => isNil(marker.mapObj)) || []);
    const toAdd = markers.filter(marker => isNil(marker.mapObj)).concat(vendorMarkers);

    if (toAdd.length > 0) {
      mapFunction(toAdd);
    }
  }

  if (comfirmRemove) {
    return <ConfirmRemoval cancel={() => setComfirmRemove(false)} remove={handleRemoveFunction} type="Marker" />;
  } else {
    return null;
  }
};

const mapStateToProps = state => ({
  vendors: state.vendors,
  activeVendors: state.activeVendors,
  leftToolbarState: state.leftToolbarState,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  markers: state.markers,
  markerTypes25: state.markerTypes25,
  auth: state.auth,
  infoWindow: state.infoWindow,
});

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  markerUpdate: marker => dispatch(markerUpdate(marker)),
  markerDeleteRequest: id => dispatch(markerDeleteRequest(id)),
  enableMapObject: () => dispatch(enableMapObject()),
  disableMapObject: () => dispatch(disableMapObject()),
  expandRightToolbar: props => dispatch(expandRightToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  infoWindowOpenAction: payload => dispatch(infoWindowOpenAction(payload)),
  selectedObjectId: payload => dispatch(selectedObjectId(payload)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RenderMarkers);

